import { createContext, useContext } from 'react'

interface GameFrameLayoutContextValue {
  registerStageWidth: (width: number) => void
}

export const GameFrameLayoutContext = createContext<GameFrameLayoutContextValue | null>(null)

export function useGameFrameLayout() {
  return useContext(GameFrameLayoutContext)
}
